package com.mgacreative.hotel.shared.ui.designsystem.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowForward
import androidx.compose.material.icons.filled.Close
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog

@Composable
fun OnboardingDialog(
    onDismiss: () -> Unit,
    onNavigateToHelp: () -> Unit,
    onNavigateToHotelProfile: () -> Unit,
    onNavigateToRoomManagement: () -> Unit
) {
    Dialog(onDismissRequest = onDismiss) {
        Surface(
            shape = RoundedCornerShape(24.dp),
            color = Color.White,
            tonalElevation = 8.dp,
            modifier = Modifier
                .fillMaxWidth()
                .widthIn(max = 520.dp)
                .padding(16.dp)
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(24.dp)
            ) {
                // Header
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column {
                        Text(
                            text = "HotelOS'e Hoş Geldiniz",
                            fontSize = 20.sp,
                            fontWeight = FontWeight.Bold,
                            color = Color(0xFF0F172A)
                        )
                        Text(
                            text = "Sistemi kullanmaya başlamak için ilk 3 adım:",
                            fontSize = 13.sp,
                            color = Color(0xFF64748B)
                        )
                    }
                    IconButton(onClick = onDismiss) {
                        Icon(
                            imageVector = Icons.Default.Close,
                            contentDescription = "Kapat",
                            tint = Color(0xFF94A3B8)
                        )
                    }
                }

                Spacer(modifier = Modifier.height(20.dp))

                // Step 1
                OnboardingStepItem(
                    stepNumber = "1",
                    title = "Oteli Tanımlayın",
                    description = "Otel adı, adres, kat sayısı ve resmi iletişim bilgilerinizi kaydedin.",
                    actionText = "Otel Profiline Git",
                    onClick = {
                        onDismiss()
                        onNavigateToHotelProfile()
                    }
                )

                Spacer(modifier = Modifier.height(12.dp))

                // Step 2
                OnboardingStepItem(
                    stepNumber = "2",
                    title = "Oda ve Tiplerini Tanımlayın",
                    description = "Oda tiplerini ve odaları (kat, kapasite, numara) eksiksiz girin.",
                    actionText = "Oda Yönetimine Git",
                    onClick = {
                        onDismiss()
                        onNavigateToRoomManagement()
                    }
                )

                Spacer(modifier = Modifier.height(12.dp))

                // Step 3
                OnboardingStepItem(
                    stepNumber = "3",
                    title = "Yardım & Destek Kılavuzunu İnceleyin",
                    description = "Rezervasyon, POS, kat hizmetleri ve personel işleyişini öğrenin.",
                    actionText = "Yardım Merkezine Git",
                    onClick = {
                        onDismiss()
                        onNavigateToHelp()
                    }
                )

                Spacer(modifier = Modifier.height(24.dp))

                // Action Buttons
                Button(
                    onClick = onDismiss,
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF2563EB)),
                    shape = RoundedCornerShape(12.dp),
                    modifier = Modifier.fillMaxWidth().height(46.dp)
                ) {
                    Text(
                        text = "Anladım, Başla",
                        fontWeight = FontWeight.SemiBold,
                        color = Color.White,
                        fontSize = 14.sp
                    )
                }
            }
        }
    }
}

@Composable
private fun OnboardingStepItem(
    stepNumber: String,
    title: String,
    description: String,
    actionText: String,
    onClick: () -> Unit
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(14.dp))
            .background(Color(0xFFF8FAFC))
            .clickable(onClick = onClick)
            .padding(14.dp)
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.fillMaxWidth()
        ) {
            Box(
                modifier = Modifier
                    .size(36.dp)
                    .clip(CircleShape)
                    .background(Color(0xFFEFF6FF)),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    text = stepNumber,
                    fontWeight = FontWeight.Bold,
                    color = Color(0xFF2563EB),
                    fontSize = 15.sp
                )
            }

            Spacer(modifier = Modifier.width(12.dp))

            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = title,
                    fontWeight = FontWeight.SemiBold,
                    fontSize = 14.sp,
                    color = Color(0xFF0F172A)
                )
                Text(
                    text = description,
                    fontSize = 12.sp,
                    color = Color(0xFF64748B),
                    lineHeight = 16.sp
                )
            }

            Spacer(modifier = Modifier.width(8.dp))

            Icon(
                imageVector = Icons.AutoMirrored.Filled.ArrowForward,
                contentDescription = actionText,
                tint = Color(0xFF2563EB),
                modifier = Modifier.size(18.dp)
            )
        }
    }
}
